module.exports = __webpack_public_path__ + "static/media/dislike.46fe8de3.svg";